import {
  Box,
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

const ProjectLocationsTable = ({ projectLocations }) => {
  if (!projectLocations || projectLocations.length === 0) {
    return (
      <Card>
        <Box padding={2}>
          <Typography
            variant="body2"
            color="text.secondary"
          >
            No projects assigned
          </Typography>
        </Box>
      </Card>
    );
  }

  return (
    <TableContainer component={Card}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Project</TableCell>
            <TableCell>Client Code</TableCell>
            <TableCell>Frequency</TableCell>
            <TableCell>Day of Week</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {projectLocations.map((pl) => (
            <TableRow key={pl._id}>
              <TableCell>{pl.projectId?.name || "N/A"}</TableCell>
              <TableCell>{pl.clientCode || "N/A"}</TableCell>
              <TableCell>{pl.frequency || "N/A"}</TableCell>
              <TableCell>{pl.dow || "N/A"}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ProjectLocationsTable;
